import { FC, useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'

/* Utils */
import { Tenant } from '../../../../models'
import { breadcrumbs } from '../../../../lib/utils'
import { useAccountName } from 'hooks/useAccountName'

/* Components */
import { CompanyInfo, DashboardLogoWrapper } from '../dashboard.styles'
import HeaderComponent from '../../../components/header/HeaderComponent'

interface Props {
  accountSettings: Tenant | null
}

/* How long to hold the logo slot empty waiting for the account's own logo. Long enough that the
 * tenant settings normally win the race, so the dashboard doesn't open on the generic logo and then
 * swap; short enough that settings which never arrive don't leave the slot blank for the session. */
const LOGO_GRACE_MS = 2000

const DashboardHeader: FC<Props> = ({ accountSettings }) => {
  const accountName = useAccountName()
  const [awaitingLogo, setAwaitingLogo] = useState(true)

  useEffect(() => {
    if (accountSettings && Object.keys(accountSettings).length) {
      setAwaitingLogo(false)
      return undefined
    }

    const timer = setTimeout(() => setAwaitingLogo(false), LOGO_GRACE_MS)
    return () => clearTimeout(timer)
  }, [accountSettings])

  return (
    <Box className="dashboard-header-wrapper">
      <HeaderComponent breadcrumbs={breadcrumbs.dashboard} type={'dashboard'}>
        <CompanyInfo>
          <DashboardLogoWrapper>
            {awaitingLogo ? (
              ''
            ) : (
              <img
                src={`${
                  accountSettings?.logo
                    ? `${process.env.REACT_APP_LOGO_HOST}${accountSettings.logo}`
                    : '/dashboard-logo.svg'
                }`}
                alt="Dashboard Logo"
              />
            )}
          </DashboardLogoWrapper>
          <Typography className="company-name">{accountName}</Typography>
        </CompanyInfo>
      </HeaderComponent>
    </Box>
  )
}

export default DashboardHeader
